import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { contactData } from '../mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="text-3xl font-light tracking-[0.3em] mb-1">SHRI</h3>
              <div className="h-px w-20 bg-white/30 mb-1" />
              <p className="text-sm tracking-[0.4em] font-light text-gray-400">ENTERPRISE</p>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Specialists in Architectural Aluminium Systems & Structural Glazing Solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm tracking-[0.3em] uppercase mb-6 font-medium">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Projects', 'Contact'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollToSection(link.toLowerCase())}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm tracking-[0.3em] uppercase mb-6 font-medium">Our Services</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>Aluminium Windows & Doors</li>
              <li>Structural Glazing</li>
              <li>Curtain Wall Systems</li>
              <li>ACP Cladding</li>
              <li>Skylights & Canopies</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm tracking-[0.3em] uppercase mb-6 font-medium">Contact Us</h4>
            <div className="space-y-4">
              <a
                href={`tel:${contactData.phone[0]}`}
                className="flex items-start gap-3 text-gray-400 hover:text-white transition-colors duration-300 group"
              >
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <div>{contactData.phone[0]}</div>
                  <div>{contactData.phone[1]}</div>
                </div>
              </a>
              <a
                href={`mailto:${contactData.email}`}
                className="flex items-start gap-3 text-gray-400 hover:text-white transition-colors duration-300 group"
              >
                <Mail className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm break-all">{contactData.email}</span>
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm leading-relaxed">{contactData.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/share/1C7kBoNU37/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/shrienterprise98?igsh=cXNweWd6MTBtb2l5"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>

            <div className="text-gray-400 text-sm">
              <span className="font-medium text-white">Coverage:</span> {contactData.coverage}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              &copy; {new Date().getFullYear()} Shri Enterprise. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button className="hover:text-white transition-colors duration-300">
                Privacy Policy
              </button>
              <button className="hover:text-white transition-colors duration-300">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};